import React from "react";
import Footer from "./Footer";
import Navbar from "./Navbar";
import NavbarStudents from "../Dashboard/Navbarlogedin";
import NavbarProfessionals from "../Interviewer/NavbarInterviewer";

const TermsAndConditions = () => {
  const user = JSON.parse(localStorage.getItem("isIAuthenticated"));
  return (
    <>
      {!user?.role ? <Navbar /> : null}
      {user?.role === "Student" ? <NavbarStudents /> : null}
      {user?.role === "Interviewer" ? <NavbarProfessionals /> : null}
      <div>TermsAndConditions</div>
      <Footer />
    </>
  );
};

export default TermsAndConditions;